import type { FrequentlyOrderDataSource } from '~/api/data-source/frequently-order';
import { frequentlyOrderDataSource } from '~/api/data-source/frequently-order';
import type { FrequentlyOrderProduct } from '~/api/model';
import { frequentlyOrderProductSchema, parseModelArray } from '~/api/model';

export interface FrequentlyOrderRepository {
  // Query
  getFrequentlyOrderProducts(): Promise<FrequentlyOrderProduct[]>;
}

export class FrequentlyOrderRepositoryImpl
  implements FrequentlyOrderRepository
{
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: FrequentlyOrderDataSource = frequentlyOrderDataSource,
  ) {}

  async getFrequentlyOrderProducts() {
    const response = await this.dataSource.getFrequentlyOrderProducts();
    return parseModelArray(
      frequentlyOrderProductSchema,
      response,
      'FrequentlyOrderProduct',
    );
  }
}

export const frequentlyOrderRepository = new FrequentlyOrderRepositoryImpl();
